import React, { useEffect, useRef, useState } from 'react';
import { formatPhone } from '../../shared';
import { Button, IconCopy } from '../../ui/v2';

/** The store's toll-free agent number, large, with Copy. */
export default function AgentNumber({ number }: { number: string }) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<number>();
  useEffect(() => () => window.clearTimeout(timer.current), []);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(formatPhone(number));
      setCopied(true);
      window.clearTimeout(timer.current);
      timer.current = window.setTimeout(() => setCopied(false), 1500);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <span className="v2-num text-v2-24 font-semibold tracking-tight text-v2-fg">
        {formatPhone(number)}
      </span>
      <Button
        size="sm"
        variant="secondary"
        leading={<IconCopy size={13} />}
        onClick={() => void copy()}
      >
        {copied ? 'Copied' : 'Copy'}
      </Button>
    </div>
  );
}
